import api from './api';
import {createGetParams} from "@/helpers";

class AuthService {

  login(credentials) {
    return api.post('/authentication/auth', credentials)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  }

  setCompanySelected(idUser, idCompany) {
    return api.post(`/authentication/auth/setCompanySelected/${ idUser }`, { idCompany: idCompany })
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  }
  setLanguageSelected(idUser, locale) {
    console.debug('API: Setting language to', locale);
    return api.post(`/authentication/auth/setLanguageSelected/${ idUser }?${ createGetParams({ locale: locale }) }`)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  }

}

export default new AuthService();
